import OpenSeadragon from 'openseadragon'
import OSDanimations from './easingOSDAnimations'

function getCurrentStepDuration(storyboard) {
  const currentImage = storyboard.stepper.currentImage
  const currentImageData = storyboard.containers.annotations[currentImage]
  const currentAnimationStep = storyboard.stepper.currentAnimationStep

  if (storyboard.firstLaunch) {
    return 0.2
  }

  return currentImageData.steps[currentAnimationStep].duration
}

function updateProgress(currentStep, totalNumberOfSteps, storyboard) {
  let storyProgress = storyboard.DOM.storyProgress
  storyProgress.style['transition'] = `all ease ${getCurrentStepDuration(storyboard)}s`

  const currentProgress = Math.round((currentStep / totalNumberOfSteps) * 100)
  storyProgress.style['width'] = `${currentProgress}%`
}

function goToNextStep(currentImageData, currentStepData, storyboard, callback) {
  storyboard.DOM.imageTitle.textContent = currentImageData.title
  storyboard.DOM.stepTitle.innerHTML =
    `${storyboard.stepper.currentGlobalAnimationStep}. ${currentStepData.label}` || ''
  storyboard.DOM.stepCaption.innerHTML = currentStepData.caption + '<br class="onlyVisibleInMobile"/>'

  updateProgress(storyboard.stepper.currentGlobalAnimationStep, storyboard.stepper.totalAnimationSteps, storyboard)

  let targetRect = new OpenSeadragon.Rect(
    currentStepData.rect.x,
    currentStepData.rect.y,
    currentStepData.rect.width,
    currentStepData.rect.height,
    currentStepData.rect.degrees
  )

  storyboard.stepper.currentRect = targetRect

  OSDanimations.animateMovement(storyboard.viewer, targetRect, currentStepData.duration * 1000)
  storyboard.stepper.currentZoom = storyboard.viewer.viewport.getZoom()
  if (callback) {
    callback()
  }
}

export default {
  animate: function (storyboard, callback) {
    storyboard.deactivateUI()
    storyboard.DOM.disableNavigator = false
    storyboard.DOM.isAnimating = true
    let currentImageData = storyboard.containers.annotations[storyboard.stepper.currentImage]
    let currentStepData = currentImageData.steps[storyboard.stepper.currentAnimationStep]

    if (storyboard.stepper.currentAnimationStep > 0) {
      storyboard.deactivateUI()
      storyboard.viewer.viewport.zoomSpring.animationTime = currentStepData.duration
      storyboard.viewer.viewport.centerSpringX.animationTime = currentStepData.duration
      storyboard.viewer.viewport.centerSpringY.animationTime = currentStepData.duration
    }

    let to = setTimeout(() => {
      clearTimeout(to)
      goToNextStep(currentImageData, currentStepData, storyboard, callback)
    }, currentStepData.delay * 500)

    storyboard.DOM.steps.forEach(function (step) {
      if (parseInt(step.dataset.stepGlobal) === storyboard.stepper.currentGlobalAnimationStep) {
        step.classList.add('selected')
      } else {
        step.classList.remove('selected')
      }
    })
  }
}
